<template>
  <div>
    <div v-if="timer != null">
      <countdown :time="timeLeft">
        <template slot-scope="props">
          <div style="background-color: aqua">Übrige Zeit：{{ props.hours }} hours, {{ props.minutes }}
            minutes, {{ props.seconds }} seconds.
          </div>
        </template>
      </countdown>
    </div>
    <div v-if="executingCourseRun === null && executingCoursePartRun === null">
      <v-card
          outlined
          tile
          style="padding: 18px"
      >
        <v-row>
          <v-img
              :src="courseRun.course.imageRef"
              class="white--text align-end" style="max-width: 200px; max-height: 200px">
          </v-img>
          <v-col>
            <p style="font-weight: bold; font-size: large;word-break: break-word">{{ courseRun.course.title }}</p>
            <p v-if="courseRun.isSuccess" class="pb-0" style="font-size: larger">
              Absolviert am {{ courseRun.courseRunDetails.successDate | moment("DD.MM.YYYY HH:mm") }}
            </p>
            <p v-else-if="courseRun.isError" class="pb-0">
              Durchgefallen am {{ courseRun.courseRunDetails.failureDate | moment("DD.MM.YYYY HH:mm") }}
            </p>
            <p v-else-if="courseRun.courseRunDetails.startDate" class="pb-0">
              Gestartet am {{ courseRun.courseRunDetails.startDate | moment("DD.MM.YYYY HH:mm") }}
            </p>

            <p v-if="courseRun.isCompound" style="word-break: break-word">Mehrteilig</p>
          </v-col>
        </v-row>

        <v-card-actions style="margin-top: 24px">
          <v-btn
              v-if="!courseRun.isCompound && courseRun.course.id!=='61cc5b61cb13df12c18d3ea6' && courseRun.course.id!=='61f95f9bcb13df12c113f391' && !courseRun.isSuccess && !courseRun.blockStart"
              color="blue" text @click="run(courseRun)">
            Kurs Starten
          </v-btn>
          <v-btn v-if="courseRun.isSuccess && courseRun.courseRunDetails.certificateDownloadAllowed" color="blue" text @click="download(courseRun)">
            Zertifikat Download
          </v-btn>
        </v-card-actions>

        <div v-if="courseRun.compoundParts.length>0">
          <h2 style="margin-top: 24px">Kursteile</h2>
          <br/>
          <v-row>
            <v-col
                v-for="part in courseRun.compoundParts"
                :key="courseRun.partId"
                cols="12"
                sm="4"
            >
              <CoursePartOverview :admin="false" :part="part" @start="startPart(part)"/>
            </v-col>
          </v-row>
        </div>

        <div v-if="courseRun.course.pdfs.length>0">
          <h2 style="margin-top: 24px">Kursdateien</h2>
          <br/>
          <v-row>
            <v-col
                v-for="(pdf, index) in courseRun.course.pdfs"
                :key="index"
                cols="12"
                sm="4">
              <v-card

              >
                <v-card-title>{{ pdf }}</v-card-title>
                <v-card-actions>
                  <v-btn
                      color="blue" text @click="downloadFile(pdf)">
                    Download
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>

        </div>
      </v-card>
      <v-snackbar :timeout="5000" :value="errorZvu" color="error" left shaped top style="margin-top: 50px">Das
        Ablaufdatum ihrer
        Zuverlässigkeitsüberprüfung fehlt oder liegt in der Vergangenheit.
      </v-snackbar>
      <v-snackbar :timeout="5000" :value="errorCheckbox" color="error" left shaped top>Die
        Bestätigung ihres
        Sicherheitsbeauftragten bzgl. der Teilnehmerüberwachung fehlt.
      </v-snackbar>
      <v-snackbar :timeout="5000" :value="errorBday" color="error" left shaped top style="margin-top: 100px">Ihr
        Geburtsdatum ist nicht
        hinterlegt.
      </v-snackbar>
    </div>
    <CourseExecution v-else-if="executingCourseRun !== null" :item="executingCourseRun"/>
    <CoursePartExecution v-else-if="executingCoursePartRun.isStepTypeStorage" :item="executingCoursePartRun"/>
    <DeclaredGoodsSite @save="onSaveDeclaredGoods" v-else-if="executingCoursePartRun.isStepTypeDeclaredGoods"
                       :item="executingCoursePartRun"/>
    <ShippersDeclarationSite @save="onSaveShippersDeclaration"
                             v-else-if="executingCoursePartRun.isStepTypeShippersDeclaration"
                             :item="executingCoursePartRun"/>
  </div>
</template>

<script>
import CourseRun from "@/models/CourseRun";
import CoursePartOverview from "@/components/CoursePartOverview.vue";
import CourseExecution from "@/components/CourseExecution.vue";
import CoursePartExecution from "@/components/CoursePartExecution.vue";
import ShippersDeclarationSite from "@/components/sites/ShippersDeclarationSite.vue";
import Vue from "vue";
import DeclaredGoodsSite from "@/components/sites/DeclaredGoodsSite.vue";
import moment from "moment/moment";

export default {
  name: "Course",
  components: {
    DeclaredGoodsSite,
    ShippersDeclarationSite, CourseExecution, CoursePartOverview, CoursePartExecution, CourseRun
  },
  props: {
    courseRun: {
      type: CourseRun
    }
  },
  computed: {
    timeLeft() {
      return (moment(this.timer).unix() - moment().unix()) * 1000
    },
  },
  mounted() {
    this.timer = this.courseRun.finishUntil
  },
  data: () => ({
    executingCourseRun: null,
    executingCoursePartRun: null,
    timer: null,
    errorText: "",
    errorBday: false,
    errorZvu: false,
    errorCheckbox: false,
  }),
  methods: {
    onSaveShippersDeclaration(declaration) {
      this.$httpUserApi.submitShippersDeclaration(declaration, this.executingCoursePartRun.courseRunId, this.executingCoursePartRun.partId, () => {
        this.executingCoursePartRun = null;
        this.$emit("reload")
      }, () => {
        this.$emit("reload")
      });
    },
    onSaveDeclaredGoods(declaration) {
      this.$httpUserApi.submitDeclaredGoods(declaration, this.executingCoursePartRun.courseRunId, this.executingCoursePartRun.partId, () => {
        this.executingCoursePartRun = null;
        this.$emit("reload")
      }, () => {
        this.$emit("reload")
      });
    },
    download(courseRun) {
      this.$httpDownloadApi.download(courseRun.courseRunDetails.certificateLink, "Zertifikat");
    },
    run(courseRun) {
      if (courseRun.hasRequirements) {
        let userId = this.$httpUserApi.userId();
        this.$httpUserApi.getUser(userId, (data) => {
          let hasError = false;
          if (courseRun.course.requireBirthdate && !data.isBirthdayValid()) {
            hasError = true;
            this.errorBday = true;
            setTimeout(() => this.errorBday = false, 3000);
          }
          if (courseRun.course.requireZvuExpirationDate && !data.isZvuPassed()) {
            hasError = true;
            this.errorZvu = true;
            setTimeout(() => this.errorZvu = false, 3000);
          }
          if (courseRun.course.requireIsHimself && !data.isHimself) {
            hasError = true;
            this.errorCheckbox = true;
            setTimeout(() => this.errorCheckbox = false, 3000);
          }

          if (hasError) {
            return null;
          } else {
            console.log("STARTING RUN");
            this.executingCourseRun = courseRun;
            this.$httpUserApi.startCourseRun(courseRun.id, (newCourseRun) => {
              this.timer = newCourseRun.finishUntil;
            }, () => {
            })
          }
        });
      } else {
        this.executingCourseRun = courseRun;
        this.$httpUserApi.startCourseRun(courseRun.id, (newCourseRun) => {
          this.timer = newCourseRun.finishUntil;
        }, () => {
        })
      }

    },
    downloadFile(pdf) {
      this.$httpDownloadApi.download(`https://lms.behrendtonline.com/behrendt/api/pdfstorage/download/${pdf}`, pdf);
    },
    setPartRunNull() {
      this.executingCoursePartRun = null;
    },
    startPart(part) {
      console.log("STARTING PART");
      console.log(part);
      this.executingCoursePartRun = part;
      this.$httpUserApi.startCourseRun(this.courseRun.id, (newCourseRun) => {
        this.timer = newCourseRun.finishUntil;
      }, () => {
      })
    }
  }
}
</script>

<style scoped>

</style>
